// 菜单Api接口
import request from '@/utils/request'

// 重置菜单 ( 由前端吊起 发js 菜单到后台存储 )
export function ResetMenu(data) {
  return request({
    url: '/Sys/SysUGP_Menu/ResetMenu',
    method: 'post',
    data: data
  })
}

// 获取所有菜单
export function GetAllMenu() {
  return request({
    url: '/Sys/SysUGP_Menu/GetAllMenu',
    method: 'get'
  })
}

//
export function GetAllPolicy() {
  return request({
    url: '/Sys/SysUGP_Menu/GetAllPolicy',
    method: 'get'
  })
}

// 获取所有菜单
export function GetUserMenu() {
  return request({
    url: '/Sys/SysUGP_Menu/GetUserMenu',
    method: 'get'
  })
}

// 获取路由信息
export function GetMenuByPath(path) {
  return request({
    url: '/Sys/SysUGP_Menu/GetMenuByPath',
    method: 'get',
    params: { path }
  })
}

// 添加
export function PostRoute(parentPath, data) {
  return request({
    url: '/Sys/SysUGP_Menu/PostRoute',
    method: 'post',
    params: { parentPath },
    data: data
  })
}

// 更新
export function PutRoute(path, data) {
  return request({
    url: '/Sys/SysUGP_Menu/PutRoute',
    method: 'put',
    params: { path },
    data: data
  })
}

// 删除
export function DeleteRoute(path) {
  return request({
    url: '/Sys/SysUGP_Menu/DeleteRoute',
    method: 'delete',
    params: { path }
  })
}

// 移动
export function PatchRoute(dropWay, path, topath) {
  return request({
    url: '/Sys/SysUGP_Menu/PatchRoute',
    method: 'patch',
    params: { dropWay, path, topath }
  })
}

export function SaveRoute(path, data, parentPath) {
  if (path !== '' && path !== null && path !== undefined) {
    // 更新
    return request({
      url: '/Sys/SysUGP_Menu/PutRoute',
      method: 'put',
      params: { path },
      data: data
    })
  } else {
    // 新增
    return request({
      url: '/Sys/SysUGP_Menu/PostRoute',
      method: 'post',
      params: { parentPath },
      data: data
    })
  }
}
